import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState, useLayoutEffect } from 'react';
import { ReactSVG } from 'react-svg';
import {
  MainWrapper,
  SheetHeadingContainer,
  SheetRow,
  EmployeeNameCell,
  SheetBodyContainer,
  VersionCell,
  EmployeeTimelineCell,
  TwoHoursCellContainer,
  EmptyNameCell,
  EmptyTimelineCell,
  GenerateBox,
  HourTick,
  HourTicksCell,
  HourLabelsCell,
  HourCaptionWrapper,
  LocationMark,
  HourCaption,
  FirstHourCaption,
  VerticalBar,
  VerticalBarsContainer,
  VerticalLinesContainer,
  VerticalLine,
  HalfHourTick,
  PastTimeOverlay
} from './DailySheet.style';
import ShiftContainer from './shiftContainer/ShiftContainer';
import notFoundIcon from '../../../assets/images/icons/file-not-found.svg';
import DailySheetTooltip from './tooltip/DailySheetTooltip';
import { timeStringToHoursCount } from '../../../util/util';
import AddNoteModal from './addNoteModal/AddNoteModal';
import { useAuthStateValue } from '../../../context/AuthContext';
import AddSectorOpeningTimeModal from './addSectorOpeningTimeModal/AddSectorOpeningTimeModal';

const DailySheet = (props) => {
  const [hourCellWidth, setHourCellWidth] = useState();
  const [timeLineGapWidth, setTimeLineGapWidth] = useState();
  const [windowSize, setWindowSize] = useState();
  const [numberOfEmptyRows, setNumberOfEmptyRows] = useState(0);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipContent, setTooltipContent] = useState(null);
  const [interval, setInterval] = useState();
  const [numberOfHours, setNumberOfHours] = useState();

  const { dataSource, version, modifiedData, setModifiedData, loading, editModeOn, latestVersionIsSelected, intervals, dayPeriod, atcu, fullScreenModeOn, versions, mainSheetRef, currentTimeUTC } = props;
  const { t } = useTranslation();
  const { loggedUser } = useAuthStateValue();
  const matchingLocationDetails = loggedUser?.locationsData?.find((el) => el?.key === atcu?.key);

  const hourCellRef = useRef();
  const timeLineRef = useRef();
  const addNoteModalRef = useRef();
  const sectorOpeningModalRef = useRef();
  let numberOfRenderedRows = 0;

  const currentTimeHours = currentTimeUTC?.getHours();
  const currentTimeMinutes = currentTimeUTC?.getMinutes();

  useEffect(() => {
    if (dayPeriod === 'ALL') {
      if (atcu?.key !== 'ALL') {
        if (intervals[matchingLocationDetails?.identificator]?.nightLatest) {
          setNumberOfHours(24 - intervals[matchingLocationDetails?.identificator]?.morningEarliest + intervals[matchingLocationDetails?.identificator]?.nightLatest);
          setInterval([intervals[matchingLocationDetails?.identificator]?.morningEarliest, intervals[matchingLocationDetails?.identificator]?.nightLatest]);
        } else {
          setNumberOfHours(intervals[matchingLocationDetails?.identificator]?.noonLatest - intervals[matchingLocationDetails?.identificator]?.morningEarliest);
          setInterval([intervals[matchingLocationDetails?.identificator]?.morningEarliest, intervals[matchingLocationDetails?.identificator]?.noonLatest]);
        }
      } else {
        setNumberOfHours(24 - intervals?.morningEarliest + intervals?.nightLatest);
        setInterval([intervals?.morningEarliest, intervals?.nightLatest]);
      }
    } else if (dayPeriod === 'MORNING') {
      if (atcu?.key !== 'ALL') {
        setNumberOfHours(intervals[matchingLocationDetails?.identificator]?.morningLatest - intervals[matchingLocationDetails?.identificator]?.morningEarliest);
        setInterval([intervals[matchingLocationDetails?.identificator]?.morningEarliest, intervals[matchingLocationDetails?.identificator]?.morningLatest]);
      } else {
        setNumberOfHours(intervals?.morningLatest - intervals.morningEarliest);
        setInterval([intervals?.morningEarliest, intervals.morningLatest]);
      }
    } else if (dayPeriod === 'NOON') {
      if (atcu?.key !== 'ALL') {
        setNumberOfHours(intervals[matchingLocationDetails?.identificator]?.noonLatest - intervals[matchingLocationDetails?.identificator]?.noonEarliest);
        setInterval([intervals[matchingLocationDetails?.identificator]?.noonEarliest, intervals[matchingLocationDetails?.identificator]?.noonLatest]);
      } else {
        setNumberOfHours(intervals?.noonLatest - intervals?.noonEarliest);
        setInterval([intervals?.noonEarliest, intervals?.noonLatest]);
      }
    } else if (dayPeriod === 'NIGHT') {
      if (atcu?.key !== 'ALL') {
        setNumberOfHours(24 - intervals[matchingLocationDetails?.identificator]?.nightEarliest + intervals[matchingLocationDetails?.identificator]?.nightLatest);
        setInterval([intervals[matchingLocationDetails?.identificator]?.nightEarliest, intervals[matchingLocationDetails?.identificator]?.nightLatest]);
      } else {
        setNumberOfHours(24 - intervals?.nightEarliest + intervals?.nightLatest);
        setInterval([intervals?.nightEarliest, intervals.nightLatest]);
      }
    } else if (dayPeriod === 'MORNING_AND_NOON') {
      if (atcu?.key !== 'ALL') {
        setNumberOfHours(intervals?.[matchingLocationDetails?.identificator]?.noonLatest - intervals?.[matchingLocationDetails?.identificator]?.morningEarliest);
        setInterval([intervals?.[matchingLocationDetails?.identificator]?.morningEarliest, intervals?.[matchingLocationDetails?.identificator]?.noonLatest]);
      } else {
        setNumberOfHours(intervals?.noonLatest - intervals?.morningEarliest);
        setInterval([intervals?.morningEarliest, intervals?.noonLatest]);
      }
    } else if (dayPeriod === 'NOON_AND_NIGHT') {
      if (atcu?.key !== 'ALL') {
        setNumberOfHours(24 - intervals?.[matchingLocationDetails?.identificator]?.noonEarliest + intervals?.[matchingLocationDetails?.identificator]?.nightLatest);
        setInterval([intervals?.[matchingLocationDetails?.identificator]?.noonEarliest, intervals?.[matchingLocationDetails?.identificator]?.nightLatest]);
      } else {
        setNumberOfHours(24 - intervals?.noonEarliest + intervals?.nightLatest);
        setInterval([intervals?.noonEarliest, intervals?.nightLatest]);
      }
    }
  }, [currentTimeHours, currentTimeMinutes, fullScreenModeOn, dataSource, intervals, fullScreenModeOn, dayPeriod, atcu]);

  let hoursElapsed = currentTimeHours + (currentTimeMinutes / 60);
  const periodsData = atcu?.key === 'ALL' ? intervals : intervals[matchingLocationDetails?.value];
  if (new Date().getDate() > parseInt(props?.day, 10)) hoursElapsed += 24;
  if (dayPeriod === 'ALL') hoursElapsed -= periodsData?.morningEarliest;
  if (dayPeriod === 'MORNING' || dayPeriod === 'MORNING_AND_NOON') hoursElapsed -= periodsData?.morningEarliest;
  if (dayPeriod === 'NOON' || dayPeriod === 'NOON_AND_NIGHT') hoursElapsed -= periodsData?.noonEarliest;
  if (dayPeriod === 'NIGHT') hoursElapsed -= periodsData?.nightEarliest;

  const getShiftPeriods = (shiftStartTime, shiftEndTime, periods) => {
    const result = [];

    function isTimeInPeriod(start, end, periodStart, periodEnd) {
      if (periodEnd < periodStart) {
        return (start >= periodStart || start < periodEnd)
            || (end > periodStart || end <= periodEnd);
      }

      return (start >= periodStart && start < periodEnd)
          || (end > periodStart && end <= periodEnd)
          || (start <= periodStart && end >= periodEnd);
    }

    if (isTimeInPeriod(shiftStartTime, shiftEndTime, periods.morningEarliest, periods.morningLatest)) {
      result.push('MORNING');
    }
    if (isTimeInPeriod(shiftStartTime, shiftEndTime, periods.noonEarliest, periods.noonLatest)) {
      result.push('NOON');
    }
    if (isTimeInPeriod(shiftStartTime, shiftEndTime + 24, periods.nightEarliest, periods.nightLatest + 24)) {
      result.push('NIGHT');
    }

    return result.length > 0 ? result : [];
  }

  const renderSheetRows = () => {
    const rowsArray = [];
    let timeLineRefAssigned = false;
    let counter = 0;
    const periodsData = atcu?.key === 'ALL' ? intervals : intervals[matchingLocationDetails?.value];
    dataSource?.controllers?.forEach((el) => {
      const shiftStartTime = timeStringToHoursCount(el?.shift?.timeFrom, false);
      const shiftEndTime = timeStringToHoursCount(el?.shift?.timeTo, true);
      const shiftPeriods = getShiftPeriods(shiftStartTime, shiftEndTime, periodsData);
      if (
          (dayPeriod === 'ALL' && (atcu?.value === 'ALL' || atcu?.value === el?.shift?.scheduledAtcu?.id))
          || ((dayPeriod === 'MORNING' && shiftStartTime < 13) && (atcu?.value === 'ALL' || atcu?.value === el?.shift?.scheduledAtcu?.id))
          || ((dayPeriod === 'NOON' && shiftPeriods?.includes('NOON')) && (atcu?.value === 'ALL' || atcu?.value === el?.shift?.scheduledAtcu?.id))
          || ((dayPeriod === 'NIGHT' && (shiftStartTime >= 18 || shiftEndTime > 21)) && (atcu?.value === 'ALL' || atcu?.value === el?.shift?.scheduledAtcu?.id))
          || ((dayPeriod === 'MORNING_AND_NOON' && (shiftPeriods.includes('MORNING') || shiftPeriods.includes('NOON'))) && (atcu?.value === 'ALL' || atcu?.value === el?.shift?.scheduledAtcu?.id))
          || ((dayPeriod === 'NOON_AND_NIGHT' && shiftStartTime >= 13) && (atcu?.value === 'ALL' || atcu?.value === el?.shift?.scheduledAtcu?.id))
      ) {
        rowsArray.push(
          <SheetRow firstRow={counter === 0} fullScreenModeOn={fullScreenModeOn}>
            <EmployeeNameCell role={el?.role}>
              {el?.firstName + ' ' + el?.lastName}
              <LocationMark>{el?.shift?.scheduledAtcu?.abbreviation}</LocationMark>
            </EmployeeNameCell>
            <EmployeeTimelineCell ref={!timeLineRefAssigned ? timeLineRef : null}>
              <ShiftContainer
                obligations={el?.obligations}
                controllerId={el?.id}
                controllerFullName={el?.firstName + ' ' + el?.lastName}
                timeFrom={el?.shift?.timeFrom}
                timeTo={el?.shift?.timeTo}
                shiftName={el?.shift?.name}
                controllerRole={el?.role}
                hourCellWidth={hourCellWidth}
                timeLineWidth={timeLineGapWidth}
                modifiedData={modifiedData}
                setModifiedData={setModifiedData}
                setTooltipVisible={setTooltipVisible}
                setTooltipContent={setTooltipContent}
                atcu={el?.shift?.scheduledAtcu?.identificator}
                interval={interval}
                dataSource={dataSource}
                editModeOn={editModeOn}
                fullScreenModeOn={fullScreenModeOn}
                addNoteModalRef={addNoteModalRef}
                sectorOpeningTimeModalRef={sectorOpeningModalRef}
              />
            </EmployeeTimelineCell>
          </SheetRow>
        );
        timeLineRefAssigned = true;
        counter += 1;
      }
    });
    numberOfRenderedRows = rowsArray?.length;
    return (<>{rowsArray}</>);
  };

  const renderEmptySheetRows = () => {
    const emptyRowsArr = [];
    for (let i = 0; i < numberOfEmptyRows; i += 1) {
      emptyRowsArr.push(
        <SheetRow style={{ marginTop: (i === 0 && !dataSource) ? '5px' : '' }}>
          <EmptyNameCell />
          <EmptyTimelineCell />
        </SheetRow>
      )
    }
    return emptyRowsArr;
  }

  useEffect(() => {
    let dayPeriodDuration;
    if (interval?.[1] > 10) dayPeriodDuration = interval?.[1] - interval?.[0];
    else if (interval?.[1] < 10) dayPeriodDuration = 24 - interval?.[0] + interval?.[1];
    else dayPeriodDuration = 24 + (interval?.[0] - interval?.[1]);
    setHourCellWidth(timeLineRef?.current?.offsetWidth / dayPeriodDuration);
    setTimeLineGapWidth(timeLineRef?.current?.clientWidth / 21);
    const minimumNumberOfRowsToRender = Math.round(mainSheetRef?.current?.offsetHeight / 45) - 1;
    setNumberOfEmptyRows(minimumNumberOfRowsToRender - numberOfRenderedRows);
  }, [dataSource, windowSize, dayPeriod, atcu, interval, fullScreenModeOn]);

  const renderVerticalBars = () => {
    const elementsArray = [];
    if (!interval) {
      for (let i = 0; i <= 23; i += 1) {
        elementsArray.push(<VerticalBar hourCellWidth={hourCellWidth} value={i} />)
      }
    } else if (interval) {
      for (let i = interval?.[0]; i <= ((interval?.[0] + numberOfHours) - 1); i += 1) {
        elementsArray.push(<VerticalBar hourCellWidth={hourCellWidth} value={i} />)
      }
    }
    return (
      <VerticalBarsContainer fullScreenModeOn={fullScreenModeOn}>
        {elementsArray}
      </VerticalBarsContainer>
    )
  }

  const renderVerticalLines = () => {
    const elementsArray = [];
    if (!interval) {
      for (let i = 0; i <= 23; i += 1) {
        elementsArray.push(<VerticalLine width={dayPeriod === 'ALL' ? 1 : 3} hourCellWidth={hourCellWidth} value={i} />);
      }
    } else if (interval) {
      for (let i = interval?.[0]; i <= ((interval?.[0] + numberOfHours) - 1); i += 1) {
        elementsArray.push(<VerticalLine width={dayPeriod === 'ALL' ? 1 : 3} hourCellWidth={hourCellWidth} value={i} />);
      }
    }
    return (
      <VerticalLinesContainer fullScreenModeOn={fullScreenModeOn}>
        {elementsArray}
      </VerticalLinesContainer>
    )
  }

  useLayoutEffect(() => {
    window.addEventListener('resize', () => {
      setWindowSize(window.innerWidth);
    });
    document.addEventListener('contextmenu', (event) => event.preventDefault());
  }, []);

  const renderHeaderRows = () => {
    const ticksArray = [];
    const hourCaptionsArr = [];

    if (!interval) {
      for (let i = 0; i <= 23; i += 1) {
        ticksArray.push(<HourTick ref={i === 0 ? hourCellRef : null} />);
        hourCaptionsArr.push(
          <HourCaptionWrapper>
            {
                i === 0 && (
                  <FirstHourCaption>00</FirstHourCaption>
                )
              }
            <HourCaption>
              {i < 23 ? ((i + 1)?.toString()?.length === 1 ? ('0' + (i + 1).toString()) : (i + 1)) : '00'}
            </HourCaption>
          </HourCaptionWrapper>
        );
      }
    } else if (interval) {
      for (let i = interval?.[0]; i <= ((interval?.[0] + numberOfHours) - 1); i += 1) {
        const n = i - interval?.[0];
        ticksArray.push(<HourTick first={i === interval?.[0]} even={n === 0 || !!(n && (n % 2))} ref={i === interval?.[0] ? hourCellRef : null}><HalfHourTick /></HourTick>);
        hourCaptionsArr.push(
          <HourCaptionWrapper>
            {
              i === interval?.[0] && (
                <FirstHourCaption>{interval?.[0]?.toString()?.length === 1 ? ('0' + interval?.[0]?.toString()) : interval?.[0]}</FirstHourCaption>
              )
            }
            <HourCaption even={n === 0 || !!(n && (n % 2))} first={i === interval?.[0]} last={i === ((interval?.[0] + numberOfHours) - 1)}>
              {i < 23 ? ((i + 1)?.toString()?.length === 1 ? ('0' + (i + 1).toString()) : (i + 1)) : ((i - 23)?.toString()?.length === 1 ? ('0' + (i - 23)) : (i - 23))}
            </HourCaption>
          </HourCaptionWrapper>
        );
      }
    }

    return (
      <>
        <SheetRow>
          <VersionCell>
            {versions?.[0] && ('ver.' + version)}
          </VersionCell>
          <TwoHoursCellContainer style={{ paddingRight: '10px' }}>
            <HourLabelsCell>
              {hourCaptionsArr}
            </HourLabelsCell>
            <HourTicksCell>
              {ticksArray}
            </HourTicksCell>
          </TwoHoursCellContainer>
        </SheetRow>
      </>
    );
  };

  return (
    <MainWrapper id="mainWrapper" ref={mainSheetRef}>
      <SheetHeadingContainer>
        {renderHeaderRows()}
      </SheetHeadingContainer>
      <SheetBodyContainer>
        {fullScreenModeOn && <PastTimeOverlay hoursElapsed={hoursElapsed} hourCellWidth={hourCellWidth} fullScreenModeOn={fullScreenModeOn} />}
        {(!!dataSource && (!editModeOn || (editModeOn && latestVersionIsSelected))) && renderVerticalBars()}
        {(!!dataSource && (!editModeOn || (editModeOn && latestVersionIsSelected))) && renderSheetRows()}
        {renderEmptySheetRows()}
        {!!dataSource && renderVerticalLines()}
      </SheetBodyContainer>
      {(!loading && (props?.notGenerated || props?.nonExistingVersion || (!latestVersionIsSelected && editModeOn))) && (
        <GenerateBox>
          <ReactSVG src={notFoundIcon} style={{ width: '100px', margin: '0 auto' }} />
          {props?.notGenerated ? t('dailySchedule.noVersionGenerated') : (props?.nonExistingVersion ? t('dailySchedule.versionDoesntExist') : t('dailySchedule.onlyLatestVersionIsEditable'))}
        </GenerateBox>
      )}
      <DailySheetTooltip visible={tooltipVisible} content={tooltipContent} sheetRef={mainSheetRef} />
      <AddNoteModal
        ref={addNoteModalRef}
        modifiedData={modifiedData}
        setModifiedData={setModifiedData}
      />
      <AddSectorOpeningTimeModal
        ref={sectorOpeningModalRef}
        modifiedData={modifiedData}
        setModifiedData={setModifiedData}
      />
    </MainWrapper>
  );
};

export default DailySheet;
